import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { theme } from '@/theme';
export const Wrapper = styled.div`
  height: auto;
  max-width: ${({ theme }) => theme.breakpoints.lg};
  margin-left: auto;
  margin-right: auto;
  ${({ theme }) => css`
    padding: ${theme.spacing(0, 1, 5, 1)};
    ${theme.media.md.up} {
      padding: ${theme.spacing(0, 5, 8, 5)};
    }
  `};
`;
export const HeaderWrapper = styled(Box)`
  ${({ theme }) => css`
    margin: ${theme.spacing(8, 0)};
    ${theme.media.md.up} {
      margin: ${theme.spacing(10, 0)};
    }
  `};
`;

export const BreadcrumbWrapper = styled(Box)`
  ${({ theme }) => css`
    margin-top: ${theme.spacing(2)};
  `};
`;

export const CardsWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  ${({ theme }) => css`
    padding: ${theme.spacing(0, 1)};
    gap: ${theme.spacing(2)};
  `}
  ${theme.media.md.up} {
    height: 448px;
    flex-direction: row;
  }
`;
export const DoubleBoxContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  ${({ theme }) => css`
    gap: ${theme.spacing(2)};
  `}
`;
